"use strict";
(function (global) {
  /**
   * Произвольный парамер прикладного метода.
   * 
   * @class WA.domainMethods.VariantParameter
   * @since 5.5.0.1000
   */
  var VariantParameter = Class.extend({
    className: 'VariantParameter',

    init: function (value, type, opt_name) {
      this.value = value;
      this.type = type;
      this.name = opt_name || "";
      return this;
    }
  });

  global.VariantParameter = VariantParameter;
})(window.WebAccess.domainMethods);